/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { initialQueryState, KTIcon, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import "./style.css"
import { PatternFormat } from "react-number-format";
import { useAuth } from '../../../../../auth';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { generateURL } from '../../../../../../../_metronic/helpers/utils';

const UsersListSearchComponent = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const {setUserPage, userPage} = useAuth()
  const { updateState } = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState(undefined)
  const [searchBy, setSearchBy] = useState('1')
  const searchParamType = searchParams.get('search_type')
  const searchParamSearch = searchParams.get('search')
  const [lastLocation, setLastLocation] = useState(null);


const searchOptions = [
  { value: '1', key: 'name', label: 'Name', placeholder: 'User Name' },
  { value: '2', key: 'phone', label: 'Phone Number', placeholder: 'Phone Number' },
  { value: '3', key: 'public_id', label: 'Member Number', placeholder: 'Member Number' },
  { value: '4', key: 'plate_number', label: 'Plate Number', placeholder: 'Plate Number' },
  { value: '5', key: 'truck_number', label: 'Truck #', placeholder: 'Truck #' },
  { value: '6', key: 'trailer_number', label: 'Trailer #', placeholder: 'Trailer #' },
  { value: '7', key: 'company_name', label: 'Company Name', placeholder: 'Company Name' },
  { value: '8', key: 'dot_number', label: 'Dot Number', placeholder: 'Dot Number' },
  { value: '9', key: 'dot_company_name', label: 'Dot Company Name', placeholder: 'Dot Company Name' },
  { value: '10', key: 'domain', label: 'Domain', placeholder: 'Domain' },
];

useEffect(() => {
  if(searchParamType || searchParamSearch){
    setSearchBy(searchParamType ? searchParamType : '1')
    setSearchTerm(searchParamSearch ? searchParamSearch : '')
  }else{
    setSearchBy('1')
    setSearchTerm('')
  }
}, [searchParams])


  const debouncedSearchTerm = useDebounce(searchTerm, 600)

  useEffect(
    () => {
      if (debouncedSearchTerm !== undefined && searchTerm !== undefined && searchBy) {
        const newUrl = generateURL('/users', {
          search_type: searchBy,
          search: debouncedSearchTerm
        })
        if (lastLocation && lastLocation !== newUrl) {
          navigate(newUrl)
        }
        setLastLocation(newUrl)
      const currentOption = searchOptions.find(option => option.value === searchBy);
        if (!currentOption) return;

        const searchKey = currentOption.key;

        const newState = searchOptions.reduce((acc, opt) => {
          acc[opt.key] = opt.key === searchKey ? debouncedSearchTerm?.trim() : '';
          return acc;
        }, { page: initialQueryState.page });

        updateState(newState);
      }
    },
    [debouncedSearchTerm]
  )


  return (
    <div className='card-title'>
      {/* begin::Search */}
      <div className='mx-5 dropdown-search'>
        <select
          className="form-select form-select-solid fw-bolder"
          data-kt-select2="true"
          data-placeholder="Select option"
          data-allow-clear="true"
          data-kt-user-table-filter="two-step"
          data-hide-search="true"
          value={searchBy}
          onChange={(e) => {
            setSearchTerm('')
            setSearchBy(e.target.value)
          }}
          autoComplete='off'
        >
        {searchOptions.map(({ value, label }) => (
         <option key={value} value={value}>{label}</option>
        ))}
        </select>
      </div>

      {searchBy && <div className='d-flex align-items-center position-relative my-1 search-container'>
        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
        {searchBy !== "2" ? <input
          type={'text'}
          data-kt-user-table-filter='text'
          className='form-control form-control-solid w-300px ps-14 user-search-input'
          placeholder={`Search by ${searchOptions.find(option => option.value === searchBy)?.placeholder}`}
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value)
            if(userPage != 1){
              setUserPage(1)
            }
          }}
          autocomplete="off"
          readOnly
          onFocus={(e) => {
            e.target.readOnly = false
          }}
          onTouchStart={(e) => {
            e.target.readOnly = false
          }}
        />
          :
          <PatternFormat
            format={"+1 (###) ###-####"}
            className={"form-control form-control-solid w-250px ps-14 user-search-input"}
            value={searchTerm}
            onValueChange={(values) => {
              setSearchTerm(values.value)
              if(userPage != 1){
                setUserPage(1)
              }
            }}
            placeholder={"Search by Phone Number"}

          />
        }
      </div>
      }
      {/* end::Search */}
    </div>
  )
}

export { UsersListSearchComponent }
